import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFiltersAddress = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters?.address || null);
